<div class="form-group">

  <small *ngIf="label">{{label}}</small>

  <ng-container *ngIf="isDialog">
    <ng-container *ngIf="controlName">
      <ng-select [items]="items"
                 class="form-control form-control-sm"
                 notFoundText="nie znaleziono dopasowań"
                 [readonly]="isDisabled"
                 bindLabel={{bindLabel}}
                 bindValue={{bindValue}}
                 (change)="ModelChange()"
                 [(ngModel)]="model[modelBindValue]"
                 [formControl]="controlName"
                 [required]="isRequired"
                 [loading]="!items"
                 [clearable]="isClearable"
                 placeholder={{placeholder}}
                 (click)="$event.stopImmediatePropagation()">

        <ng-template ng-option-tmp let-item="item">
          {{item[bindLabel]}}

          <app-badges [Item]="item">
          </app-badges>

        </ng-template>
      </ng-select>
    </ng-container>

    <ng-container *ngIf="!controlName">
      <ng-select [items]="items"
                 class="form-control form-control-sm"
                 notFoundText="nie znaleziono dopasowań"
                 [readonly]="isDisabled"
                 bindLabel={{bindLabel}}
                 bindValue={{bindValue}}
                 (change)="ModelChange()"
                 [(ngModel)]="model[modelBindValue]"
                 [required]="isRequired"
                 [loading]="!items"
                 [clearable]="isClearable"
                 placeholder={{placeholder}}
                 (click)="$event.stopImmediatePropagation()">

        <ng-template ng-option-tmp let-item="item">
          {{item[bindLabel]}}

          <app-badges [Item]="item">
          </app-badges>

        </ng-template>
      </ng-select>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="!isDialog">
    <ng-container *ngIf="controlName">
      <ng-select [items]="items" appendTo="body"
                 class="form-control form-control-sm"
                 notFoundText="nie znaleziono dopasowań"
                 [readonly]="isDisabled"
                 bindLabel={{bindLabel}}
                 bindValue={{bindValue}}
                 (change)="ModelChange()"
                 [(ngModel)]="model[modelBindValue]"
                 [formControl]="controlName"
                 [required]="isRequired"
                 [loading]="!items"
                 [clearable]="isClearable"
                 placeholder={{placeholder}}
                 (click)="$event.stopImmediatePropagation()">

        <ng-template ng-option-tmp let-item="item">
          {{item[bindLabel]}}

          <app-badges [Item]="item">
          </app-badges>

        </ng-template>
      </ng-select>
    </ng-container>

    <ng-container *ngIf="!controlName">
      <ng-select [items]="items" appendTo="body"
                 class="form-control form-control-sm"
                 notFoundText="nie znaleziono dopasowań"
                 [readonly]="isDisabled"
                 bindLabel={{bindLabel}}
                 bindValue={{bindValue}}
                 (change)="ModelChange()"
                 [(ngModel)]="model[modelBindValue]"
                 [required]="isRequired"
                 [loading]="!items"
                 [clearable]="isClearable"
                 placeholder={{placeholder}}
                 (click)="$event.stopImmediatePropagation()">

        <ng-template ng-option-tmp let-item="item">
          {{item[bindLabel]}}

          <app-badges [Item]="item">
          </app-badges>

        </ng-template>
      </ng-select>
    </ng-container>
  </ng-container>

  <small *ngIf="!inlineControl && isRequired" class="text-muted  validator-information">Pole wymagane</small>
</div>

